import React from "react";

import { makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";

const selectorFocusable = `
  a[href]:not([tabindex="-1"]),
  area[href],
  input:not([disabled]):not([tabindex="-1"]),
  select:not([disabled]):not([tabindex="-1"]),
  textarea:not([disabled]):not([tabindex="-1"]),
  button:not([disabled]):not([tabindex="-1"]),
  [tabindex="0"],
  [contenteditable="true"]
`;

const useStyles = makeStyles({
  root: {},
  wrap: {},
  limit: {
    opacity: 0,
    fontSize: 0,
    position: "absolute",
    pointerEvents: "none",
  },
});

const RbTrapFocus = React.forwardRef(function RbTrapFocus(props, ref) {
  const { children, autoFocus } = props;

  const classes = useStyles();

  const wrapRef = React.useRef();

  const handleLimitTopFocus = () => {
    const focusables = wrapRef.current.querySelectorAll(selectorFocusable);
    const lastFocusable = focusables[focusables.length - 1];
    if (lastFocusable) {
      lastFocusable.focus();
    }
  };

  const handleLimitBottomFocus = () => {
    const firstFocusable = wrapRef.current.querySelector(selectorFocusable);
    if (firstFocusable) {
      firstFocusable.focus();
    }
  };

  React.useEffect(() => {
    if (autoFocus) {
      handleLimitBottomFocus();
    }
  }, [autoFocus]);

  return (
    <div className={classes.root} ref={ref}>
      <button
        className={classes.limit}
        onFocus={handleLimitTopFocus}
        aria-hidden="true"
        type="button"
        aria-label="Focus trap top limit"
      />
      <div ref={wrapRef} className={classes.wrap}>
        {children}
      </div>
      <button
        className={classes.limit}
        onFocus={handleLimitBottomFocus}
        aria-hidden="true"
        type="button"
        aria-label="Focus trap bottom limit"
      />
    </div>
  );
});

RbTrapFocus.propTypes = {
  children: PropTypes.node,
  autoFocus: PropTypes.bool,
};

RbTrapFocus.defaultProps = {
  children: null,
  autoFocus: true,
};

export default RbTrapFocus;
